import React, { useEffect, useState } from "react";
import CommonButton from "../../../Components/Buttons/CommonButton";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { handleloading } from "../../../Store/Redux/Reducers/Dashboardreducers";
import {
  DeleterUserDevice,
  DropdownService,
  UserListDeviceMapping,
} from "../../../Services/ApiServices";
import {
  CatchMessage,
  JSONtoformdata,
  MomentDateTime,
  getValidData,
  tokenisValid,
} from "../../../Shared/Methods";
import { toast } from "react-toastify";
import { HandleSessionModal } from "../../../Store/Redux/Reducers/Authreducers";
import { Col, Row } from "antd";
import classes from "./user.module.css";
import manimage from "../../../Assests/Images/man.png";
import AddUserdevicemodal from "../../../Modals/User/AddUserDeviceModal";
import Commontooltip from "../../../Components/CommonTooltip/Commontooltip";
import editimg from "../../../Assests/Images/pencil.png";
import deleteimg from "../../../Assests/Images/delete.png";
import Commonpagination from "../../../Components/Tables/CommonPagination";
import CommonNodataFound from "../../../Components/CommonNodataFound";
import DeleteConfirmation from "../../../Modals/DeleteConfirmation";

function Viewuserdevice() {
  const navigate = useNavigate();
  const location = useLocation();
  const { state } = location || {};
  const { item } = state || {};
  const { LoginData } = useSelector((state: any) => state.Auth);
  const dispatch = useDispatch();
  const [listUserDevice, setUserDevice] = useState<any>([]);
  const [pageSize, setpageSize] = useState(10);
  const [pageind, setPageInd] = useState(0);
  const [DropDowns, setDropDowns] = useState({
    Device: [],
    isDeviceLoading: true,
  });
  const [addUserDevice, setAddUserDevice] = useState<any>({
    isView: false,
    item: {},
    action: "",
  });
  const { items, page, size, total_count } = listUserDevice;
  const [showmodal, setShowModal] = useState({
    isView: false,
    action: "",
    item: "",
  });
  const [showConfirmModal, setShowConfirmModal] = useState<any>({
    isView: false,
    item: "",
  });

  useEffect(() => {
    if (LoginData !== null) {
      handleListUserDevice();
      getDeviceDropDown();
    }
  }, [LoginData]);

  const handleListUserDevice = (page = 1, size = 10) => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      user_id: item?.id,
      organization_id: item?.organization_id,
    };

    UserListDeviceMapping(page, size, JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res.data.status === 1) {
          setUserDevice(res.data.data);

          setPageInd(page > 1 ? page - 1 : 0);
        } else if (res.data.status === -1) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res.data.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const getDeviceDropDown = () => {
    // dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      user_id: item?.id,
    };
    DropdownService(JSONtoformdata(finalObj), "dropDownDeviceMap")
      .then(async (res) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isDeviceLoading: false,
          };
        });
        if (res?.data?.status === 1) {
          setDropDowns((pre) => {
            return {
              ...pre,
              Device: res.data.data,
            };
          });
        } else if (res?.data?.status === 0) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res?.data?.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res?.data?.msg);
        }
      })
      .catch((err) => {
        setDropDowns((pre) => {
          return {
            ...pre,
            isDeviceLoading: false,
          };
        });
        CatchMessage(err);
      });
    // .finally(() => {
    //   dispatch(handleloading(false));
    // });
  };

  const Changesize = (current: number, size: number) => {
    // setPageInd(0); //change into 0 from 1
    setpageSize(size);
    handleListUserDevice(1, size);
  };

  const DeleteDevice = (id: number) => {
    dispatch(handleloading(true));

    let finalObj = {
      token: LoginData?.token,
      mapping_id: id,
    };
    DeleterUserDevice(JSONtoformdata(finalObj))
      .then(async (res) => {
        if (res.data.status === 1) {
          toast.success(res.data.msg);
          setPageInd(
            listUserDevice?.items?.length === 1 && listUserDevice?.page !== 1
              ? pageind - 1
              : pageind
          );
          handleListUserDevice(
            listUserDevice?.items?.length === 1 && listUserDevice?.page !== 1
              ? listUserDevice?.page - 1
              : listUserDevice?.page,
            pageSize
          );
          handleCancel();
        } else if (res.data.status === -1) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res.data.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => dispatch(handleloading(false)));
  };

  const handleCancel = () => {
    setAddUserDevice({ isView: false, item: {}, action: "" });
    setShowConfirmModal({ isView: false, item: "" });
    setDropDowns((pre) => {
      return {
        ...pre,
        isDeviceLoading: true,
      };
    });
  };

  return (
    <>
      {showConfirmModal?.isView ? (
        <DeleteConfirmation
          handleSuccess={() => {
            DeleteDevice(showConfirmModal?.item?.id);
          }}
          itemName={showConfirmModal?.item?.device_code || "Device"}
          Delete={true}
          open={showConfirmModal?.isView}
          closable={!showConfirmModal?.isView}
          onCancel={handleCancel}
        />
      ) : null}

      {addUserDevice?.isView ? (
        <AddUserdevicemodal
          handleSuccess={() => {
            handleListUserDevice(1, 10);
          }}
          onCancel={handleCancel}
          item={addUserDevice?.item}
          closable={!addUserDevice?.isView}
          open={addUserDevice?.isView}
          DropDowns={DropDowns}
          DropdownMethods={{
            getDeviceDropDown,
          }}
          action={addUserDevice?.action}
        />
      ) : null}

      <div>
        <div className="header_container">
          <h3 style={{ marginBottom: "12px" }}>User Details</h3>

          <CommonButton
            name="Back"
            onClick={() => navigate("/user")}
            type="button"
            style={{ background: "red", fontSize: 17, maxWidth: 112 }}
            classname="back_button"
          />
        </div>

        {/* <h3 style={{ marginBottom: "12px" }}>User Details</h3> */}
        <Row gutter={[16, 16]}>
          <Col xxl={10} xl={13} lg={18} md={24} sm={24} xs={24}>
            <div
              className="primarycard h-100 p-3"
              style={{
                border: "4px solid #20a2a08a",
              }}
            >
              <div
                className={`${classes.viewdevice_container}`}
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "60px",
                  flexFlow: "wrap",
                }}
              >
                <div>
                  <div className={classes.user_image_container}>
                    <img
                      src={manimage}
                      alt="man"
                      className={classes.user_image}
                    />
                  </div>
                </div>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  <div className={classes.profile} style={{ gap: "12px" }}>
                    <h2
                      className="m-0"
                      style={{ color: "rgb(169 34 82)", fontSize: "35px" }}
                    >
                      {getValidData(item?.name)}
                    </h2>

                    <h6>
                      User Name : <span>{getValidData(item?.username)} </span>
                    </h6>

                    <h6>
                      E-mail : <span>{getValidData(item?.email)} </span>
                    </h6>

                    <h6>
                      Mobile : <span>{getValidData(item?.phone)}</span>
                    </h6>

                    <h6>
                      Alternative Mobile :{" "}
                      <span>{getValidData(item?.alternativeNumber)}</span>
                    </h6>

                    <h6>
                      Created at :{" "}
                      <span>
                        {getValidData(
                          item?.created_at
                            ? MomentDateTime(item?.created_at)
                            : null
                        )}
                      </span>
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </Col>
        </Row>

        <div className="primarycard mt-3">
          <div>
            <div className=" d-flex  justify-content-between ">
              <h3
                style={{ marginBottom: "12px" }}
                className="device_heading_style"
              >
                Device Details
              </h3>

              <CommonButton
                type="button"
                onClick={() =>
                  setAddUserDevice({
                    isView: true,
                    item: item,
                    action: "Assign",
                  })
                }
                name="Assign Device"
                classname="create_btn"
                style={{ padding: "6px 6px", maxWidth: "140px" }}
              />
            </div>
          </div>
          <div>
            <Row gutter={[16, 16]}>
              {items?.length > 0 ? (
                items?.map((ele: any, index: any) => {
                  return (
                    <>
                      <Col xxl={6} lg={8} md={12} xs={24} key={index}>
                        <div
                          className={`${classes.device_alert_settings_container} h-100`}
                        >
                          <div>
                            {/* <p style={{ fontWeight: 600 }}>
                              {ele?.device_code}
                            </p> */}

                            <Commontooltip
                              children={
                                <p
                                  style={{ fontWeight: 600 }}
                                  className="cards_name_heading"
                                >
                                  {ele?.device_code}
                                </p>
                              }
                              msg={ele?.device_code}
                              placement="topLeft"
                            />

                            <div>
                              <Commontooltip
                                children={
                                  <img
                                    src={editimg}
                                    onClick={() =>
                                      setAddUserDevice({
                                        isView: true,
                                        item: ele,
                                        action: "Update",
                                      })
                                    }
                                    style={{ width: "15px", height: "15px" }}
                                    alt="editimg"
                                  />
                                }
                                msg="Update"
                              />

                              <Commontooltip
                                children={
                                  <img
                                    src={deleteimg}
                                    alt="deleteimg"
                                    style={{ width: "18px", height: "18px" }}
                                    onClick={() =>
                                      setShowConfirmModal({
                                        isView: true,
                                        item: ele,
                                      })
                                    }
                                  />
                                }
                                msg="Delete"
                              />
                            </div>
                          </div>

                          {/* <div style={{ padding: "12px 12px 3px" }}>
                            <div>
                              <p>
                                Meter Code :{" "}
                                <span>{getValidData(ele?.meter_code)}</span>
                              </p>
                            </div>
                            <div className="align-items-end">
                              <p>
                                Register Type :{" "}
                                <span>{getValidData(ele?.register_type)}</span>
                              </p>
                            </div>
                          </div> */}

                          <p
                            style={{
                              fontWeight: 600,
                              color: "#000000d6",
                              fontSize: 15,
                              padding: "12px 12px 3px",
                            }}
                          >
                            Access Type :{" "}
                            <span
                              style={{
                                fontWeight: 600,
                                color: "rgba(0, 0, 0, 0.5)",
                                fontSize: 15,
                              }}
                            >
                              {ele?.access_type === 1 ? "Edit" : "View"}
                            </span>
                          </p>

                          <p
                            style={{
                              fontWeight: 600,
                              color: "#000000d6",
                              fontSize: 15,
                              padding: "0px 12px 3px",
                            }}
                          >
                            Organization Code :{" "}
                            <span
                              style={{
                                fontWeight: 600,
                                color: "rgba(0, 0, 0, 0.5)",
                                fontSize: 15,
                              }}
                            >
                              {getValidData(ele?.organization_code)}
                            </span>
                          </p>

                          <p
                            style={{
                              fontWeight: 600,
                              color: "#000000d6",
                              fontSize: 15,
                              padding: "0px 12px 12px",
                            }}
                          >
                            Created At :{" "}
                            <span
                              style={{
                                fontWeight: 600,
                                color: "rgba(0, 0, 0, 0.5)",
                                fontSize: 15,
                              }}
                            >
                              {getValidData(
                                ele?.created_at
                                  ? MomentDateTime(ele?.created_at)
                                  : ""
                              )}
                            </span>
                          </p>
                        </div>
                      </Col>
                    </>
                  );
                })
              ) : (
                <CommonNodataFound />
              )}
            </Row>
            <Commonpagination
              onShowSizeChange={Changesize} ///call when page size click
              total={total_count}
              current={page}
              pageSize={size}
              onChange={(e, size) => {
                ///call when page number click
                if (size === pageSize) {
                  handleListUserDevice(e, size);
                }
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Viewuserdevice;
